import React from 'react';
import { ClipboardList, MailCheck, Send, TrendingUp, ArrowRight } from 'lucide-react';
import { steps } from '../mock';

const icons = [ClipboardList, MailCheck, Send, TrendingUp];

export default function Steps() {
  return (
    <section className="bg-[#15120f] py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="text-center">
          <p className="font-heading text-sm font-bold uppercase tracking-[0.2em] text-orange-500">How It Works</p>
          <h2 className="mt-2 font-heading text-4xl font-extrabold text-white sm:text-5xl">Start Winning In 4 Simple Steps</h2>
        </div>
        <div className="mt-14 grid gap-8 md:grid-cols-4">
          {steps.map((s, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="relative text-center">
                <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl border border-[#2e2822] bg-[#1e1913] shadow-lg">
                  <Icon className="h-9 w-9 text-orange-500" strokeWidth={1.8} />
                  <span className="absolute -mt-16 ml-16 flex h-7 w-7 items-center justify-center rounded-full bg-orange-500 font-heading text-sm font-bold text-[#15120f]">{i + 1}</span>
                </div>
                {i < steps.length - 1 && (
                  <ArrowRight className="absolute right-[-22px] top-8 hidden h-6 w-6 text-orange-500/40 md:block" />
                )}
                <h3 className="mt-5 font-heading text-xl font-bold text-white">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-neutral-400">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
